(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.ValidationEngine = (function() {
    function ValidationEngine() {
      this.startValidating = bind(this.startValidating, this);
      this.stopValidating = bind(this.stopValidating, this);
      this.isValidating = bind(this.isValidating, this);
      this.revalidateInput = bind(this.revalidateInput, this);
      this.revalidateEvent = bind(this.revalidateEvent, this);
      this.forms = [];
      this.rules = [];
      this.gbl_callback = null;
      this.validating = true;
      this.invalidInputs = [];
      this.event = {
        'change.mfvalidate': this.revalidateEvent
      };
      this.registerRule({
        selector: '.validate-required',
        text: '%s is required',
        func: function(elem) {
          var val;
          val = elem.val();
          return !!val && val !== 'undefined';
        }
      });
      this.registerRule({
        selector: '.validate-date',
        text: '%s must be a valid date',
        func: function(elem) {
          var val;
          val = elem.val();
          return !val || !!Date.parse(val);
        }
      });
      this.registerRule({
        selector: '.validate-email',
        text: 'The email address you entered is not properly formatted',
        func: function(elem) {
          return $(elem).val().length === 0 || $(elem).val().match(/^[\w._%+-]+@[\w.-]+\.[A-za-z]{2,6}$/);
        }
      });
      this.registerRule({
        selector: '.validate-tags-required',
        text: '%s is required',
        func: function(elem) {
          if (elem.is('div') && elem.hasClass('select2-container')) {
            return elem.find('.select2-search-choice').length > 0;
          } else {
            return true;
          }
        }
      });
      this.registerRule({
        selector: '.validate-hasOptions',
        text: '%s must be populated',
        func: function(elem) {
          var options;
          options = $(elem).find('option');
          return options.length > 0;
        }
      });
      this.registerRule({
        selector: '.validate-isPositive',
        text: '%s must be greater than 0',
        func: function(elem) {
          var val;
          val = elem.val();
          return !val || ($.isNumeric(val) && parseFloat(val) > 0);
        }
      });
      this.registerRule({
        selector: '.validate-notLessThanZero',
        text: '%s cannot be less than 0',
        func: function(elem) {
          var val;
          val = elem.val();
          return !val || ($.isNumeric(val) && parseFloat(val) >= 0);
        }
      });
      this.registerRule({
        selector: '.validate-isNumeric',
        text: '%s must be a numeric value',
        func: function(elem) {
          var val;
          val = elem.val();
          return !val || $.isNumeric(val);
        }
      });
      this.registerRule({
        selector: '.validate-isInteger',
        text: '%s must be a whole number',
        func: function(elem) {
          var val;
          val = elem.val();
          return !val || ($.isNumeric(val) && val % 1 === 0);
        }
      });
      this.registerRule({
        selector: '.validate-required-if-enabled',
        text: '%s is required',
        func: function(elem) {
          var val;
          if (elem.is('[disabled]')) {
            return true;
          }
          val = elem.val();
          return !!val && val !== 'undefined';
        }
      });
      this.registerRule({
        selector: '.validate-required-if-visible',
        text: '%s is required',
        func: function(elem) {
          var val;
          if (!elem.is(':visible')) {
            return true;
          }
          val = elem.val();
          return !!val && val !== 'undefined';
        }
      });
      this.registerRule({
        selector: '.validate-max',
        text: function(elem, name) {
          return name + " cannot have more than " + (elem.data('max')) + " characters";
        },
        func: function(elem) {
          var max;
          max = elem.data('max');
          return elem.val().length <= max;
        }
      });
      this.registerRule({
        selector: '.validate-min',
        text: function(elem, name) {
          return name + " cannot have fewer than " + (elem.data('min')) + " characters";
        },
        func: function(elem) {
          var min;
          min = elem.data('min');
          return elem.val().length >= min;
        }
      });
      this.registerRule({
        selector: '.validate-select2-required',
        text: '%s is required',
        func: function(elem) {
          var val;
          if (elem.is('input')) {
            val = elem.val();
            return !!val && val !== 'undefined';
          } else {
            return true;
          }
        }
      });
    }

    ValidationEngine.prototype.registerRule = function(obj) {
      var form, name, ref, results;
      this.rules[obj.selector] = obj;
      ref = this.forms;
      results = [];
      for (name in ref) {
        form = ref[name];
        results.push(form.selector.on(this.event, "" + obj.selector));
      }
      return results;
    };

    ValidationEngine.prototype.makeFormValidator = function(name, selector, errorDiv, callback) {
      var cls, obj, ref, results;
      if (!(selector instanceof jQuery)) {
        selector = $(selector);
      }
      if (!(errorDiv instanceof jQuery)) {
        errorDiv = $(errorDiv);
      }
      this.forms[name] = {
        'selector': selector,
        'errorDiv': errorDiv,
        'func': callback
      };
      errorDiv.message_writer({
        autohide: false
      });
      ref = this.rules;
      results = [];
      for (cls in ref) {
        obj = ref[cls];
        results.push(selector.on(this.event, "" + cls));
      }
      return results;
    };

    ValidationEngine.prototype.setCallback = function(callback) {
      return this.gbl_callback = callback;
    };

    ValidationEngine.prototype.clearErrors = function() {
      var errorDiv, form, name, ref, results;
      ref = this.forms;
      results = [];
      for (name in ref) {
        form = ref[name];
        errorDiv = form.errorDiv;
        if (errorDiv.length) {
          results.push(errorDiv.empty().message_writer('hide', 0));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ValidationEngine.prototype.revalidateEvent = function(e) {
      return this.revalidateInput(e.target);
    };

    ValidationEngine.prototype.revalidateInput = function(elem) {
      var attr, cls, elems, form, name, ref, results, rule;
      if (!this.validating) {
        return;
      }
      if (!(elem instanceof jQuery)) {
        elem = $(elem);
      }
      this.invalidInputs = [];
      ref = this.forms;
      results = [];
      for (name in ref) {
        form = ref[name];
        if (elem.closest(form.selector).length !== 0) {
          results.push((function() {
            var ref1, results1;
            ref1 = this.rules;
            results1 = [];
            for (cls in ref1) {
              rule = ref1[cls];
              if ((rule.group != null) && (elem.data(rule.group.attr) != null)) {
                attr = elem.data(rule.group.attr);
                elems = form.selector.find(cls + "[data-" + rule.group.attr + "='" + attr + "']");
                results1.push(this.validateInput(elems, cls, form, attr));
              } else if (elem.is(cls)) {
                results1.push(this.validateInput(elem, cls, form));
              } else {
                results1.push(void 0);
              }
            }
            return results1;
          }).call(this));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    ValidationEngine.prototype.validateUnconditionally = function() {
      var form, name, ref, results;
      ref = this.forms;
      results = [];
      for (name in ref) {
        form = ref[name];
        results.push(form.func(true));
      }
      return results;
    };

    ValidationEngine.prototype.validateAll = function(callFunc) {
      var form, name, ref, results;
      if (callFunc == null) {
        callFunc = true;
      }
      if (!this.validating) {
        return;
      }
      ref = this.forms;
      results = [];
      for (name in ref) {
        form = ref[name];
        results.push(this.validateForm(name, callFunc));
      }
      return results;
    };

    ValidationEngine.prototype.validateForm = function(name, callFunc) {
      var attr, cls, elem, form, group, groups, j, len, ref, ref1, rule, valid;
      if (callFunc == null) {
        callFunc = true;
      }
      if (!this.validating) {
        return;
      }
      form = this.forms[name];
      if (!form.selector.length) {
        return;
      }
      form.deferred = $.when();
      valid = true;
      this.invalidInputs = [];
      ref = this.rules;
      for (cls in ref) {
        rule = ref[cls];
        groups = [];
        ref1 = form.selector.find(cls);
        for (j = 0, len = ref1.length; j < len; j++) {
          elem = ref1[j];
          elem = $(elem);
          if ((rule.group != null) && (elem.data(rule.group.attr) != null)) {
            attr = elem.data(rule.group.attr);
            if (groups[attr] == null) {
              groups[attr] = $();
            }
            groups[attr] = groups[attr].add(elem);
          } else {
            if (!this.validateInput(elem, cls, form)) {
              valid = false;
            }
          }
        }
        for (attr in groups) {
          group = groups[attr];
          if (!this.validateInput(group, cls, form, attr)) {
            valid = false;
          }
        }
      }
      form.deferred.always(function() {
        if (callFunc) {
          return form.func(valid && form.deferred.state() === 'resolved');
        }
      });
      return valid;
    };

    ValidationEngine.prototype.validateInput = function(elem, cls, form, attr) {
      var ajax, rule;
      if (attr == null) {
        attr = null;
      }
      if (!this.validating) {
        return;
      }
      rule = this.rules[cls];
      if (rule.ajax) {
        ajax = $.post(rule.ajax.url, rule.ajax.data(elem));
        ajax.fail((function(_this) {
          return function() {
            return _this.handleValidationResult(elem, rule, form.errorDiv, false, attr);
          };
        })(this));
        ajax = ajax.then((function(_this) {
          return function(response) {
            if (rule.func(response)) {
              _this.handleValidationResult(elem, rule, form.errorDiv, true, attr);
              return response;
            } else {
              _this.handleValidationResult(elem, rule, form.errorDiv, false, attr);
              return $.Deferred().reject(response);
            }
          };
        })(this));
        ajax.then((function(_this) {
          return function(response) {
            return response;
          };
        })(this), (function(_this) {
          return function(response) {
            return response;
          };
        })(this));
        form.deferred = $.when(form.deferred, ajax);
        return true;
      } else {
        return this.handleValidationResult(elem, rule, form.errorDiv, rule.func(elem), attr);
      }
    };

    ValidationEngine.prototype.handleValidationResult = function(elem, rule, errorDiv, returnStatus, attr) {
      var invalid, name, pTag, text;
      if (attr == null) {
        attr = null;
      }
      if (elem.length === 0) {
        return;
      }
      if ((rule.group != null) && elem.length > 1) {
        name = rule.group.name;
        if (name == null) {
          name = this.getInputName(elem);
        }
        if (attr) {
          name = name.replace('%g', attr);
        }
      } else {
        name = this.getInputName(elem);
      }
      name = name.replace(/'/g, '');
      if (returnStatus) {
        invalid = false;
        elem.each((function(_this) {
          return function(i, domEl) {
            var el, j, len, ref;
            ref = _this.invalidInputs;
            for (j = 0, len = ref.length; j < len; j++) {
              el = ref[j];
              if (el === domEl) {
                invalid = true;
                break;
              }
            }
            if (invalid) {
              return false;
            }
          };
        })(this));
        if (!invalid) {
          elem.removeClass("mfvalidate-invalid-" + rule.selector);
        }
        errorDiv.find("p[data-error-cls='" + rule.selector + "'][data-error-name='" + name + "']").remove();
        if (errorDiv.has('p[data-error-cls][data-error-name]').length === 0 && $.contains(document, errorDiv[0])) {
          errorDiv.message_writer('clear');
        } else if ($.contains(document, errorDiv[0])) {
          errorDiv.message_writer('show');
        }
      } else {
        elem.addClass("mfvalidate-invalid-" + rule.selector);
        if (typeof rule.text === 'function') {
          text = rule.text(elem, name);
        } else {
          text = rule.text.replace('%s', name);
        }
        pTag = errorDiv.find("p[data-error-cls='" + rule.selector + "'][data-error-name='" + name + "']");
        if (pTag.length === 0) {
          errorDiv.append("<p data-error-cls='" + rule.selector + "' data-error-name='" + name + "'>" + text + "</p>");
        } else {
          pTag.html(text);
        }
        if ($.contains(document, errorDiv[0])) {
          errorDiv.message_writer('show');
        }
        elem.each((function(_this) {
          return function(i, domEl) {
            return _this.invalidInputs.push(domEl);
          };
        })(this));
      }
      return returnStatus;
    };

    ValidationEngine.prototype.getInputName = function(input) {
      var name;
      if (!(input instanceof jQuery)) {
        input = $(input);
      }
      name = input.data('validation-name');
      if (name) {
        return name;
      }
      name = $("label[for='" + (input.attr('id')) + "']");
      if (name.length) {
        return name.text().replace(/:|\s*\*\s*/g, '');
      }
      name = input.attr('name');
      if ((name != null) && (name.replace != null)) {
        return name.replace(/_|-/g, ' ').replace(/\w\S*/g, function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
      }
      return 'Input';
    };

    ValidationEngine.prototype.isValidating = function() {
      return this.validating;
    };

    ValidationEngine.prototype.stopValidating = function() {
      return this.validating = false;
    };

    ValidationEngine.prototype.startValidating = function() {
      return this.validating = true;
    };

    return ValidationEngine;

  })();

}).call(this);
